import { TRootState } from 'store';

export const getEmail = (state: TRootState) => state.forgotPassword.email;
export const isLoading = (state: TRootState) => state.forgotPassword.isLoading;
export const getErrorText = (state: TRootState) => state.forgotPassword.error;
export const getSuccessText = (state: TRootState) =>
  state.forgotPassword.success;
